export default class DeliveryOrderModel {
  constructor() {
    this.deliveryId = '';
    this.displayId = '';
    this.storeId = '';
    this.storePhone = '';
    this.agentId = '';
    this.introducerId = '';
    this.introducerBonus = 0;
    this.deliveryStaff = '';
    this.city = '';
    this.street = '';
    this.address = '';
    this.transportPrice = 0;
    this.discount = 1;
    this.agentBonus = 0;
    this.paymentType = 0;
    this.paymentStatus = 0;
    this.paymentDate = '';
    this.comment = '';
    this.deliveryStatus = 0;
    this.deliveryDate = '';
    this.price = 0;
    this.realPrice = 0;
    this.productList = [];
  }
}



// WEBPACK FOOTER //
// ./src/models/DeliveryOrderModel.js